module.exports = __webpack_public_path__ + "static/c3-be4eeac558c9a2495c7f7c7bb8eaf7cc.png";